import React, { useEffect, useState } from "react";
import { Header } from "build-ts/metadata";
import { listScheduledJobs } from "services/ScheduleServices";
import AnalystJobs from "modules/analyst/components/AnalystJobs";

interface AnalystJobsContainerProps {
  analystId: string | undefined;
  setIsViewingOrEditingJob?: (value: boolean) => void;
  initialJobId?: string;
  analystName?: string;
}

const AnalystJobsContainer: React.FC<AnalystJobsContainerProps> = ({
  analystId,
  setIsViewingOrEditingJob,
  initialJobId,
  analystName,
}) => {
  // Start in loading state immediately when deep-linking to a specific job
  const [jobs, setJobs] = useState<Header[]>([]);
  const [isLoading, setIsLoading] = useState(!!initialJobId);

  const getJobs = async (id: string) => {
    setIsLoading(true);
    const response = await listScheduledJobs(
      "SCENARIO_JOB",
      -1,
      1,
      id,
      "LAST_MODIFIED",
      false,
      true,  /* includeScheduleActivity */
      "",    /* activeSchedule */
    );
    setJobs(response ?? []);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!analystId) return;
    getJobs(analystId);
  }, [analystId]);

  return (
    <AnalystJobs
      analystId={analystId}
      jobs={jobs}
      isLoading={isLoading}
      onRefresh={() => analystId && getJobs(analystId)}
      setIsViewingOrEditingJob={setIsViewingOrEditingJob}
      initialJobId={initialJobId}
      analystName={analystName}
    />
  );
};

export default AnalystJobsContainer;
